/**
 * TCGPlayer product link used on the buying queue (source + Printing + Near Mint).
 */

export function tcgPlayerNearMintUrl(
  sourceId: string | null,
  printing: string | null,
): string | null {
  if (!sourceId) return null;
  const productId = sourceId.split(/[#/]/)[0]?.trim();
  if (!productId) return null;
  const print = printing ?? sourceId.split("#")[1] ?? null;
  const params = new URLSearchParams();
  if (print) params.set("Printing", print);
  params.set("Condition", "Near Mint");
  return `https://www.tcgplayer.com/product/${productId}?${params.toString()}`;
}

function printingIn(record: unknown): string | null {
  if (!record || typeof record !== "object") return null;
  const value = (record as Record<string, unknown>).printing;
  return typeof value === "string" && value.trim() ? value : null;
}

/**
 * The item's TCGPlayer printing. The boxed ETL writes it to `pricing_ref.printing` beside the
 * product id; a hand-made item may carry it on `attributes.printing` instead.
 */
export function printingForItem(input: {
  pricingRef: unknown;
  attributes: unknown;
}): string | null {
  return printingIn(input.pricingRef) ?? printingIn(input.attributes);
}
